import { Reveal, SectionHeading } from "./Reveal";
import { SERVICE_GROUPS } from "@/data/site";

const Services = () => (
  <section
    id="services"
    data-testid="services-section"
    className="scroll-mt-24 bg-slate-50 bg-grid-light py-24 md:py-32 lg:py-40"
  >
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <SectionHeading
        overline="Our Services"
        title="Everything Your Business Needs To Go Digital"
        text="From AI-powered customer communication to premium websites and custom software — practical technology, built around your requirements."
      />

      <div className="mt-20 space-y-20">
        {SERVICE_GROUPS.map((group, gi) => (
          <div key={group.id}>
            <Reveal>
              <div className="flex items-baseline gap-4">
                <span className="font-display text-sm font-medium text-electric">
                  0{gi + 1}
                </span>
                <div>
                  <p className="text-xs font-bold uppercase tracking-[0.22em] text-electric">
                    {group.overline}
                  </p>
                  <h3 className="mt-1 font-display text-2xl font-medium tracking-tight text-slate-900 md:text-3xl">
                    {group.title}
                  </h3>
                </div>
              </div>
            </Reveal>
            <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
              {group.services.map((service, i) => (
                <Reveal key={service.title} delay={i * 0.07}>
                  <div
                    data-testid={`service-card-${service.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="group h-full rounded-2xl border border-slate-200 bg-white p-8 shadow-sm transition-[box-shadow,transform,border-color] duration-500 hover:-translate-y-1 hover:border-electric/30 hover:shadow-xl"
                  >
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-electric/10 transition-[transform,background-color] duration-500 group-hover:rotate-3 group-hover:scale-110 group-hover:bg-electric/15">
                      <service.icon className="h-6 w-6 text-electric" strokeWidth={1.5} />
                    </div>
                    <h4 className="mt-6 font-display text-lg font-medium text-slate-900">
                      {service.title}
                    </h4>
                    <p className="mt-3 text-sm leading-relaxed text-slate-600">{service.text}</p>
                    <a
                      href="#contact"
                      data-testid={`service-enquire-${service.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                      className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-electric transition-colors duration-300 hover:text-electric-bright"
                    >
                      Enquire
                      <span aria-hidden className="transition-transform duration-300 group-hover:translate-x-1">→</span>
                    </a>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
